import { BenefitsType } from "../../interfaces/benefits/Benefits.type";
import Benefits from "../benefits/Benefits";
import styles from "./BenefitGroup.module.css";

export default function BenefitGroup({
                                              items,
                                          }: {
    items: BenefitsType[];
}) {
    const item = items[0];
    return (
        <div className={`vas-card vas-flex-column vas-gap-3 ${styles.white_border} vas-border-radius vas-align-item vas-d-flex vas-p-3 vas-w-100`}>
            <Benefits item={item} />
        </div>
    );
}
